import React, { FC, useEffect } from 'react'
import { createPortal } from 'react-dom'
import './styles.scss'

type PopUpType = {
  handleAccept: () => void
  handleReject: () => void
  acceptText: string
  rejectText: string
  title: string
  description: string
  isOpen: boolean
  onClose: () => void
}

const PopUpConfirm: FC<PopUpType> = ({
  handleAccept,
  handleReject,
  acceptText,
  rejectText,
  title,
  description,
  isOpen,
  onClose
}) => {
  const popupRoot = document.getElementById('root')

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    if (isOpen) {
      document.body.style.overflow = 'hidden'
      document.addEventListener('keydown', handleEscape)
    }

    return () => {
      document.body.style.overflow = ''
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen || !popupRoot) return null

  return createPortal(
    <div className="popup-overlay-confirm" onClick={onClose}>
      <div className="popup" onClick={e => e.stopPropagation()}>
        <p className="regexi">{title}</p>
        <p>{description}</p>
        <div className="button-container">
          <button className="accept-button" onClick={handleAccept}>
            {acceptText}
          </button>
          <button className="reject-button" onClick={handleReject}>
            {rejectText}
          </button>
        </div>
      </div>
    </div>,
    popupRoot
  )
}

export default PopUpConfirm
